import { TextField, MenuItem, Stack } from "@mui/material"
import { useState, useEffect } from "react"
import { API } from "../../services/API/API";
import Chip from '../Tools/Chip';
import { txt } from "../../services/translation";

export default function Category({value, onChange, required, disabled, sx}){

    const [categories, setCategories] = useState([]);

    useEffect(() => {

        API.getCategories()
            .then(r => setCategories(Array.isArray(r.data) ? r.data : []))
            .catch(e => console.log(e))

    }, [value])


    return <TextField
        label={txt('healthSector')}
        select
        size='small'
        value={(categories.length > 0 && value?.id) || (required ? '' : 'all')}
        onChange={e => onChange(categories.find(c => c.id === e.target.value) || null)}
        required={required ? true : false}
        disabled={disabled}
        sx={sx || {}}
    >

        {!required && 
            <MenuItem value='all'>{txt('all')}</MenuItem>
        }

        {categories.map(c => 
            <MenuItem key={c.id} value={c.id}>
                <Stack direction='row' alignItems='center' spacing={2}>
                    <Chip color={c.color} opacity={0.8} />
                    <span>{txt(c.id)}</span>
                </Stack>
            </MenuItem>    
        )}
        
    </TextField>
}